/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */

App.ready(() => App.search_filters.init());


App.search_filters = {

  init() {
    return $(document)
      .off("click", ".js-search-filter", this.clicked)
      .on("click", ".js-search-filter", this.clicked);
  },


  clicked(evt) {
    let matches;
    const $this  = $(this);
    const $field = $( $this.attr("data-field") );

    if (!$field.length) { return; }

    const filter = $this.text();
    let val    = $field.val();
    const re     = new RegExp(`(\\s*${filter})`, "gi");

    if (matches = val.match(re)) {
      val = val.replace(matches[0], "");
    } else {
      val = `${val} ${filter}`;
    }

    return $field.val(val);
  }
};
